import { Routes } from '@angular/router';
import { AppConfig } from '@mkp/shared/util-app-config';
import { ActiveTrafficFunnelGuard, hasTokenInUrl } from '@mkp/core/feature-guard';

export const visitorOnlyUrls = {
  home: AppConfig.routes.home,
  onboarding: AppConfig.routes.onboarding,
  onboardingFunnel: `${AppConfig.routes.onboarding}/:funnel`,
  login: AppConfig.routes.login,
  passwordlessLogin: AppConfig.routes.passwordlessLogin,
  passwordlessLoginLinkSent: AppConfig.routes.passwordlessLoginLinkSent,
  passwordlessLoginLinkExpired: AppConfig.routes.passwordlessLoginLinkExpired,
  resetPassword: AppConfig.routes.resetPassword,
};

export const visitorUrls = {
  error404: AppConfig.routes.error404,
  redeemInvite: AppConfig.routes.redeemInvite,
  invalidLinkError: AppConfig.routes.invalidInvite,
  cookieSettings: AppConfig.routes.cookieSettings,
  ...visitorOnlyUrls,
};

export const visitorRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('@mkp/layout/shell-user-layout').then((m) => m.ShellUserLayoutComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: visitorUrls.home,
      },
      {
        path: visitorUrls.redeemInvite,
        canActivate: [hasTokenInUrl],
        loadComponent: () =>
          import('@mkp/user-account-membership/feature-user-management').then(
            (m) => m.RedeemInviteComponent
          ),
      },
      {
        path: visitorUrls.home,
        data: { title: 'META_TITLE.HOME' },
        loadComponent: () => import('@mkp/core/feature-home').then((m) => m.HomeComponent),
      },
      {
        path: visitorUrls.cookieSettings,
        data: { title: 'META_TITLE.COOKIE_SETTINGS' },
        loadComponent: () =>
          import('@mkp/gdpr/feature-gdpr-consent').then((m) => m.CookieSettingsRouteComponent),
      },
      {
        path: visitorUrls.login,
        data: { title: 'META_TITLE.LOGIN' },
        loadChildren: () => import('@mkp/user/feature-login').then((m) => m.userFeatureLoginRoutes),
      },
      {
        path: visitorUrls.passwordlessLogin,
        data: { title: 'META_TITLE.LOGIN' },
        loadChildren: () =>
          import('@mkp/user/feature-passwordless-login').then(
            (m) => m.userFeaturePasswordlessLoginRoutes
          ),
      },
      {
        path: visitorUrls.resetPassword,
        data: { title: 'META_TITLE.RESETPASSWORD' },
        loadComponent: () =>
          import('@mkp/user/feature-reset-password').then((m) => m.ResetPasswordComponent),
      },
      {
        path: visitorUrls.onboarding,
        children: [
          {
            path: '',
            data: { title: 'META_TITLE.ONBOARDING' },
            loadComponent: () =>
              import('@mkp/onboarding/feature-onboarding').then((m) => m.OnboardingComponent),
          },
          {
            path: ':funnel',
            canActivate: [ActiveTrafficFunnelGuard],
            data: { title: 'META_TITLE.ONBOARDING' },
            loadComponent: () =>
              import('@mkp/onboarding/feature-onboarding').then((m) => m.OnboardingComponent),
          },
        ],
      },
      {
        path: visitorUrls.error404,
        loadComponent: () => import('@mkp/core/feature-errors').then((m) => m.Error404Component),
        data: { title: 'META_TITLE.ERROR.404' },
      },
      {
        path: visitorUrls.invalidLinkError,
        loadComponent: () =>
          import('@mkp/user-account-membership/feature-user-management').then(
            (m) => m.InvalidInviteComponent
          ),
      },
    ],
  },
  { path: '**', redirectTo: '/' + visitorUrls.error404 },
];
